<div *ngIf="isCompleted" class="alert alert-danger" role="alert">
  <h3><span>Вы уже сдавали этот тест {{currentSubjectTest.attempts}} раза.</span></h3>
</div>
<div class="d-flex justify-content-center text-selection-none">
  <div class="col-lg-8 col-md-9 col-9 p-0 course-content text-selection-none">
    <div class="card shadow bg-white rounded m-2">
      <div class="card-body">
        <div class='answerSideButton'>
          <button (click)="openSideBox()" class="btn timerButton">Время</button>
        </div>
        <h4 class="card-subtitle mb-2 text-center">{{currentSubjectTest.title}}</h4>
        <div *ngFor="let question of currentSubjectTest.questions; let i=index" class="question-div">
          <div><strong>{{i + 1}}.</strong></div>
          <div>
            <div>
              <figure *ngIf="question.questionImgUrl" class="image">
                <img src="{{question.questionImgUrl}}">
              </figure>
              <div *ngIf="question.questionText.length>0">
                <span [innerHTML]="question.questionText"></span>
              </div>
            </div>
          </div>
          <div *ngFor="let opt of options; let ik=index">
            <div *ngIf="question.options[ik].optionText.length>0 || question.options[ik].optionImgUrl.length>0"
                 class="column question-box">
              <div [id]="'option-'+i.toString()+opt.label" class="variants">
                <div class="option-variant">
                  <button (click)="onChange($event.target.value,i+1)"
                          [class.firstSelect]="ansBox[i+1].firstSelectedAns==opt.label"
                          [class.lastSelect]="ansBox[i+1].reSelectedAns==opt.label"
                          class="checkboxButtons"
                          value="{{opt.label}}"></button>
                  ({{opt.ru}})
                </div>
                <div style="padding-left: 6px;">
                  <figure *ngIf="question.options[ik].optionImgUrl.length>0" class="image is-48x48 is-inline-block">
                    <img src="{{question.options[ik].optionImgUrl}}">
                  </figure>
                  <div *ngIf="question.options[ik].optionText.length>0" class="is-inline-block">
                    <span [innerHTML]="question.options[ik].optionText"></span></div>

                </div>
                <span *ngIf="showResult && question.options[ik].isCorrect">
              <i class="fas fa-check"></i></span>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="card-footer">
        <div class="buttons-2">
          <button (click)="checkTest()" [disabled]="isCompleted"
                  class="btn btn-danger btn-rounded btn-md ml-4" data-target="#pract" data-toggle="modal" role="button"
                  type="button">Закончить тест
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="col-lg-3 col-md-3 col-3 left-panel-menu">

    <div class="card shadow bg-white rounded m-2 timerColumn">
      <h2 class="card-title text-center">Время</h2>
      <h2 style="font-size: 31px; text-align: center; font-weight: 300;">{{countDownTimer}}</h2>

    </div>
  </div>

  <div [ngClass]="{'openAnswerBox' : openSide}" class="for-mobile-only answer-box">

    <div class="card shadow bg-white rounded m-2">
      <h2 class="card-title text-center">Время</h2>
      <h2 style="font-size: 31px; text-align: center; font-weight: 300;">{{countDownTimer}}</h2>

    </div>
  </div>
</div>


<div aria-labelledby="myModalLabel" class="modal fade text-selection-none" data-backdrop="static" id="pract"
     role="dialog">
  <div class="modal-dialog" role="document">
    <!--Content-->
    <div class="modal-content">
      <!--Body-->
      <div class="modal-body">
        <h1 style="font-size: large; text-align: center;">Резултаты теста</h1>
        <h1 style="font-size: xx-large; text-align: center;">{{currentSubjectTest.title}}</h1>
        <div>
          <h1>
            <span style="font-size: 20px; color:#4757e9; font-weight: 600;">Правильно : </span>
            <span style="font-size: 25px; color:green;font-weight: 700;">{{correctAnswers}}</span>
          </h1>
        </div>
        <div>
          <h1>
            <span style="font-size: 20px; color:#4757e9; font-weight: 600;">Не правильно : </span>
            <span style="font-size: 25px; color:red;font-weight: 700;">{{wrongAnswers}}</span>
          </h1>
        </div>
        <div>
          <h1>
            <span style="font-size: 20px; color:#4757e9; font-weight: 600;">Балл : </span>
            <span style="font-size: 25px;font-weight: 700;">{{totalScore}}</span>
          </h1>
        </div>
      </div>
      <!--Footer-->
      <div class="modal-footer">

        <div class="buttons-2 d-flex">
          <button (click)="finishReview()"
                  class="btn btn-outline-danger btn-rounded btn-md ml-4"
                  data-dismiss="modal"
                  type="button">Закрыть
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

<div aria-labelledby="myModalLabel" class="modal fade text-selection-none" data-backdrop="static"
     id="attempts"
     role="dialog">
  <div class="modal-dialog" role="document">
    <!--Content-->
    <div class="modal-content">
      <!--Body-->
      <div class="modal-body">
        <div>
          <h1>
            <span
              style="font-size: 20px; color:#4757e9; font-weight: 600;">Вы уже сдавали этот тест {{currentSubjectTest.attempts}}
              раза. </span>
          </h1>
        </div>
      </div>
      <div class="modal-footer">

        <div class="buttons-2 d-flex">
          <button (click)="finish()"
                  class="btn btn-outline-danger btn-rounded btn-md ml-4"
                  data-dismiss="modal"
                  type="button">Закрыть
          </button>
        </div>

      </div>
    </div>
  </div>
</div>

